import { useHistory } from 'react-router-dom'

export const useIsLeasingSearch = () => {
    const { location } = useHistory()
    return location.pathname.includes('-leasing-search')
}
